import { useQuery } from '@tanstack/react-query';
import { schoolBandsApi } from '@/features/reports/api';

export const groupComparisonsFilterQueryKeys = {
  schoolBands: (year: string) => ['groupComparisons', 'schoolBands', year] as const,
  tuitionBands: (year: string) => ['groupComparisons', 'tuitionBands', year] as const,
  parentBands: (year: string) => ['groupComparisons', 'parentBands', year] as const,
};

/** GET /api/app/school-bands?Year=…&ExcludeDetails=true */
export function useGroupComparisonsSchoolBandsQuery(year: string | undefined) {
  const y = year?.trim() ?? '';
  const yearNum = Number(y);
  const enabled = y !== '' && Number.isFinite(yearNum);

  return useQuery({
    queryKey: groupComparisonsFilterQueryKeys.schoolBands(y),
    queryFn: () =>
      schoolBandsApi.getList({
        year: yearNum,
        excludeDetails: true,
        skipCount: 0,
        maxResultCount: 100,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
